import MDRouter from "@/service/router";
import imgUrlFilter from 'md-base-tools/imgUrlFilter';
import { domPixelRatio } from 'md-base-tools/env';
export default {
  props: {
    rednoteInfo: {
      type: Object
    }
  },
  data() {
    return {
      radio: parseInt(domPixelRatio()) || 1
      // img: '',
      // tit: '',
      // update_id: ''
    };
  },
  methods: {
    goDrawInfo() {
      MDRouter.goRednoteDetail(this.rednoteInfo.activity_id);
    },
    imgUrlFilter() {
      return imgUrlFilter(...arguments);
    }
  }
};